import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters' // 导入响应的模块
import * as actions from './actions'
import * as mutations from './mutations'

Vue.use(Vuex)
// 首先声明一个状态 state
const state = {
  resturantId: 0,        // 餐馆ID
  resturantName: '全部门店', // 门店名称
  statisticalDate: ''   // 统计日期
}
// 注册相应模块才能使用
const store = new Vuex.Store({
  state,        // 共享的状态或数据
  getters,      // 获取数据并渲染
  actions,      // 数据的异步操作
  mutations     // 处理数据的唯一途径
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js